import { render, staticRenderFns } from "./AvitoCityAdd.vue?vue&type=template&id=8e685c92&"
import script from "./AvitoCityAdd.vue?vue&type=script&lang=js&"
export * from "./AvitoCityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports